module.exports = "/_next/static/videos/baseball-1-11cbab364bf2453585e8a86bf2c8c37e.webm";